import React,{useEffect, useState} from 'react'
import Lottie from 'react-lottie'
import Modal from 'react-modal'
import { useAuth0 } from '@auth0/auth0-react'

import {fetchPosts} from '../redux/index'
import { newLike } from '../redux/index'
import { newComment } from '../redux/index'
import {connect} from 'react-redux'
import loadingAnimation from '../images/loadingAnimation.json'
import errorAnimation from '../images/errorAnimation.json'
import LikeButton from './button/likeButton/likeButton'

function ForumPosts({posts,getPosts, putComment, doLike}) {

  const {loginWithPopup,loginWithRedirect,logout,user, isAuthenticated, isLoading} = useAuth0()

    const [readMoreModalOpen, setReadMoreModalOpen] = useState(false)
    const [userCreated, setUserCreated] = useState("")
    const [title, setTitle] = useState("")
    const [desc, setDesc] = useState("")
    const [likes, setLikes] = useState([])
    const [comments, setCommments] = useState([])
    const [currComment, setCurrComment] = useState("")
    const [currPostId, setCurrPostId] = useState("")
    const [likeFound, setLikeFound] = useState(false)

    const style_survey_text={ color:"#23374D", fontFamily:"Krona One, sans-serif", fontSize:"14px"}
    const animOptions={
        loop: true,
        autoplay: true,
      animationData: loadingAnimation,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }

    const errAnimOptions={
        loop: true,
        autoplay: true,
      animationData: errorAnimation,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }

    const isLiked= likes.some(el=>{
      if(el.likedBy==user.name)
      {return true;}
    });

    useEffect(()=>{
      getPosts()
    },[])

    const postComment=()=>{
      const commentData = {id:currPostId,commentedBy: user.name, commentedOn: new Date().toLocaleString(), commentBody: currComment};
      putComment(commentData)
    }

    return (
        <div className="forum__body1" style={{boxShadow:"inset 5px 5px 5px rgba(0,0,0,0.2),inset -5px -5px 15px rgba(255,255,255,0.1),5px 5px 15px rgba(0,0,0,0.3),-5px -5px 15px rgba(255,255,255,0.1)",flexDirection:"column",top:"0",borderRadius:"10px",display:"flex",  alignItems:"center" ,flexWrap:"wrap",flex:"0.8",margin:"20px",minWidth:"400px",minHeight:"80vh",overflowY:"hidden",overflowX:"hidden"}} >
        <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",alignItems:"center"}}><span style={{ color:"#23374D", fontFamily:"Krona One, sans-serif", fontSize:"2rem",marginTop:"10px"}}>SHARE YOUR THOUGHTS</span><a href=""><img onClick={()=>{window.location.replace('/forum')}} src="refresh-icon.png" style={{width:"50px"}}/></a></div>
           
           {posts.loading?(<Lottie
                        options={animOptions}
                        height={400}
                        width={400}
                    />):(posts.error?(<><Lottie options={errAnimOptions} height={400} width={400}/></>):(<></>))}
       
       <div className='postsBox' style={{display:"flex", flexDirection:"column", height:"80vh", overflowY:"scroll", width:"100%"}}>
       { posts && posts.posts && posts.posts.map((elem)=><div className="card" style={{width:"95%", margin:"10px"}}>
             <div className="box">
             <div className="content" style={style_survey_text}>
            <div className="title" style={{}}>
                {elem.title}
            </div>
            <div className="post_body"style={{fontSize:"1.1rem", color:"85C3FF"}}>
                {elem.body} 
            </div>
            <button onClick={()=>{setTitle(elem.title); setUserCreated(elem.userCreated?elem.userCreated:""); setDesc(elem.body); setCurrPostId(elem._id); setCommments(elem.comments); setLikes(elem.likes); setReadMoreModalOpen(true);}} style={{width:"100px",height:"20px"}}> <p style={{fontSize:"10px"}}>Read More</p></button>


            </div>

             </div>
        </div>)}
        </div>

        <Modal isOpen={readMoreModalOpen} contentLabel="EXAMPLE MODAL">
                  <div className="otp_modal">
                    <div className="otp_modal_header">
                    <div className="otp_modal_header_text">
                    <h1  style={{fontFamily:"Krona One, sans-serif",justifyContent:"center"}}>POST DETAILS</h1>
                    </div>
                    <img className="otp_modal_close_icon" src='close-icon.png' alt="" onClick={()=>{setReadMoreModalOpen(false)}}/>
                    </div>

                    <div className="confirmDetails_modal_body">
                      <div>ID: {currPostId}</div>
                       <div className="dispField name">{title}</div>
                       <div className="dispField name">By: {userCreated}</div>
                       <div className="dispField name">Description:  {desc}</div>
                       <div className="dispField name">Liked by:  {likes.length}</div>
                       
                       <div style={{display:"flex"}} ><input placeholder="Comment here..." value={currComment} onChange={(e)=>{setCurrComment(e.target.value)}} style={{margin:"10px"}}/> <button onClick={postComment}>Comment</button> </div>
                       <div className="dispField name">Comments: </div>
                       {comments?.map((el)=>(<div><span>{el.commentedBy} : {el.commentBody}</span></div>))}
                    </div>
                    {isLiked?(<><h1>LIKED</h1></>):(<><LikeButton/></>)}
                  </div>
                </Modal>

        


           </div>
    )
}

const mapStateToProps=(state)=>{
  return{
      posts: state.fetchedPosts
  }
}

const mapDispatchToProps=(dispatch)=>{
  return{
      getPosts: ()=>dispatch(fetchPosts()),
      putComment: (commentData)=>dispatch(newComment(commentData)),
      doLike: (likeData)=>dispatch(newLike(likeData))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ForumPosts)

